'use client';

import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { cardAnimation } from '@/utils/animations';

const Card = ({
  children,
  className = '',
  padding = 'default',
  shadow = 'default',
  rounded = 'default',
  ...props
}) => {
  const baseClasses = 'bg-white border border-primary/10 hover:border-accent/20';
  
  const paddingClasses = {
    none: '',
    small: 'p-4',
    default: 'p-6',
    large: 'p-8',
  };
  
  const shadowClasses = {
    none: '',
    small: 'shadow-sm',
    default: 'shadow-md',
    large: 'shadow-lg',
  };
  
  const roundedClasses = {
    none: '',
    small: 'rounded',
    default: 'rounded-lg',
    large: 'rounded-xl',
  };
  
  const cardClasses = `${baseClasses} ${paddingClasses[padding]} ${shadowClasses[shadow]} ${roundedClasses[rounded]} ${className}`;
  
  return (
    <motion.div data-component-id="src/components/ui/Card.jsx:42:4" data-component-path="src/components/ui/Card.jsx" data-component-line="42" data-component-end-line="53" data-component-file="Card.jsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%2C%22className%22%3A%22%5Bvar%3AcardClasses%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" 
      className={cardClasses}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-100px" }}
      variants={cardAnimation}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  padding: PropTypes.oneOf(['none', 'small', 'default', 'large']),
  shadow: PropTypes.oneOf(['none', 'small', 'default', 'large']),
  rounded: PropTypes.oneOf(['none', 'small', 'default', 'large']),
};

export default Card;